videojs.addLanguage('fr', {
  "hotKeyLable": "Raccourcis clavier"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_modal_hotkey/dist/lang/fr.js
// module id = 724
// module chunks = 0